import { makeAutoObservable } from 'mobx';
import { ICareLogStore, CareLogFiltersType } from './types';

export class CareLogStore implements ICareLogStore {
  filters: { [id: string]: CareLogFiltersType } = {};

  constructor(defaultValues = {}) {
    makeAutoObservable(this);
    this.filters = defaultValues;
  }

  setFilter(key: string, value: CareLogFiltersType) {
    this.filters[key] = value;
  }

  clearFilters() {
    this.filters = {};
  }
}
